"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconCross = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const IconCross = (props) => ((0, jsx_runtime_1.jsx)("svg", Object.assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props, { children: (0, jsx_runtime_1.jsx)("path", { fill: "#464650", fillRule: "evenodd", d: "M12.707,12 L19.853,4.854 C20.049,4.658 20.049,4.342 19.853,4.146 C19.658,3.951 19.342,3.951 19.146,4.146 L12,11.293 L4.853,4.146 C4.658,3.951 4.342,3.951 4.146,4.146 C3.951,4.342 3.951,4.658 4.146,4.854 L11.293,12 L4.146,19.146 C3.951,19.342 3.951,19.658 4.146,19.854 C4.244,19.951 4.372,20 4.5,20 C4.628,20 4.756,19.951 4.853,19.854 L12,12.707 L19.146,19.854 C19.244,19.951 19.372,20 19.5,20 C19.628,20 19.756,19.951 19.853,19.854 C20.049,19.658 20.049,19.342 19.853,19.146 L12.707,12 Z" }) })));
exports.IconCross = IconCross;
exports.IconCross.defaultProps = {
    height: '30px',
    width: '30px',
};
exports.default = exports.IconCross;
